

function scrollTopAnimated() {
  var body = $("html, body");
  body.stop().animate({scrollTop:0}, 2000, 'swing', function() { 
    
  });
}

jQuery( document ).ready(function($){
  /*
    $("main.main-content .common-header-part" ).clone(true).appendTo('[data-section-id="header"]');
    $("main.main-content .common-header-part").remove();
  if($("body.template-index").length>0){
    var oseid = getUrlParameter('oseid');
    if(oseid){
    var interval = setInterval(function(){ 
     $( ".home-header-message-content" ).clone(true).appendTo('[data-section-id="header"]');
     $("#PageContainer .home-header-message-content").remove();
    clearInterval(interval);
    }, 1000);
    }else{
       $( ".home-header-message-content" ).clone(true).appendTo('[data-section-id="header"]');
       $("#PageContainer .home-header-message-content").remove();
    }
   $('[data-section-id="header"]').addClass("top-backgorund-banner"); 
  
}
  */
  if($("body .common-target-plan").length > 0){
    var totalCurrentPoints = $("body .common-target-plan .number-format.number-count").html();
        totalCurrentPoints = parseInt(totalCurrentPoints);
  	var apiKey       = "b71af8bb896bc85efc9a6d9cc185adc7";
	var apiPassword  = "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";
	var apiVersion   = "2021-07";
	var apiBaseUrl   = "forester-eco.myshopify.com";
	var apiFullUrl   = "https://"+apiKey+":"+apiPassword+"@"+apiBaseUrl+"/admin/api/"+apiVersion+"/";
	var apiRequestUrl=apiFullUrl+"orders.json";
    var dataMax      = $("body .common-target-plan .progressbar-line[data-position]").attr("data-max");
    var percent      = 0;
    
  
  $.get( apiRequestUrl, function( dataOrder ) {
    $.each(dataOrder.orders, function (i,order) {
      $.each(order.line_items, function (pkey, product) {
           apiRequestUrl = apiFullUrl+"products/"+product.product_id+"/metafields.json";
           $.get( apiRequestUrl, function( metafields ) {
               $.each(metafields.metafields, function (mkey, metafield) {
                 if(metafield.key=="sale_points"){
                     //console.log(metafield.value);
                   totalCurrentPoints = totalCurrentPoints+metafield.value;
                   percent = percentage(totalCurrentPoints,dataMax);
                   $("body .common-target-plan .number-format.number-count").html(totalCurrentPoints);
                   $("body .common-target-plan .progressbar-line").attr("data-position",percent);
                  }
               });
            });
      });
    });
 });
  
  }
  /* 
   $('.number-count').each(function () {
    $(this).prop('Counter',0).animate({
        Counter: $(this).text()
    }, {
        duration: 4000,
        easing: 'swing',
        step: function (now) {
        $(this).text(Math.ceil(now));

          var str = $(this).html() + ''; 
          x = str.split('.'); 
          x1 = x[0]; x2 = x.length > 1 ? '.' + x[1] : ''; 
          var rgx = /(\d+)(\d{3})/; 
          while (rgx.test(x1)) { 
              x1 = x1.replace(rgx, '$1' + ',' + '$2'); 
          } 
          $(this).html(x1 + x2); 

        }
    });
});

  */


$('.number-format').text(function () { 
    var str = $(this).html() + ''; 
    x = str.split('.'); 
    x1 = x[0]; x2 = x.length > 1 ? '.' + x[1] : ''; 
    var rgx = /(\d+)(\d{3})/; 
    while (rgx.test(x1)) { 
        x1 = x1.replace(rgx, '$1' + '.' + '$2'); 
    } 
    $(this).html(x1 + x2); 
});
  
if($("body.template-page.contact-us").length > 0){ 
      $("form.contact-form input[type=submit]").on('click',function(){
         setCookie("contact_form_id",$(this).data('id'));
      });
    
    if($("form.contact-form .form-message").length > 0){
      $("form.contact-form .form-message").hide();
      if(getCookie("contact_form_id")){ 
        $("form#"+getCookie("contact_form_id")+" .form-message").show();
          $('html, body').animate({
               scrollTop: $("#"+getCookie("contact_form_id")).offset().top-180
           }, 2000);
        }
 }}
   
   
   
   
   
  // Get all the toggletip buttons
  var toggletips = document.querySelectorAll('[data-toggletip-content]');

  // Iterate over them
  Array.prototype.forEach.call(toggletips, function (toggletip) {
    // Get the message from the data-content element
    var message = toggletip.getAttribute('data-toggletip-content');

    // Get the live region element
    var liveRegion = toggletip.nextElementSibling;

    // Toggle the message
    toggletip.addEventListener('click', function () {
        liveRegion.innerHTML = '';
        window.setTimeout(function() {
          liveRegion.innerHTML = '<span class="toggletip-bubble">'+ message +'</span>';
        }, 100);
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (toggletip !== e.target) {
        liveRegion.innerHTML = '';
      }                        
    });

    // Remove toggletip on ESC
    toggletip.addEventListener('keydown', function (e) {
      if ((e.keyCode || e.which) === 27)
      liveRegion.innerHTML = '';
    });
    
    // Remove on blur
    toggletip.addEventListener('blur', function (e) {
      liveRegion.innerHTML = '';
    });
  });
  
  
  
  /*---------------------  Video section ------------------------*/



// $(document).on('click','.js-videoPoster',function(ev) {
//   ev.preventDefault();
//   var $poster = $(this);
//   var $wrapper = $poster.closest('.js-videoWrapper');
//   videoPlay($wrapper);
// });

$(document).on('click','.js-videoPoster',function(ev) {
  ev.preventDefault();
  var $poster = $(this);
  var $wrapper =$('.js-videoWrapper');
  videoPlay($wrapper);
  $(".youtube-popup").fadeIn(1000);
  $(".overlay").fadeIn(500);
  //$("body").css('overflow','hidden');
  

});


function videoPlay($wrapper) {
  var $iframe = $wrapper.find('.js-videoIframe');
  var src = $iframe.data('src');
  $wrapper.addClass('videoWrapperActive');
  $iframe.attr('src',src);

  
  var youtubecode = $(".youtube-code").val();
  $(".youtube-popup .videoIframe").attr('src',youtubecode)
}


function videoStop($wrapper) {
  if (!$wrapper) {
    var $wrapper = $('.js-videoWrapper');
    var $iframe = $('.js-videoIframe');
  } else {
    var $iframe = $wrapper.find('.js-videoIframe');
  }
  $wrapper.removeClass('videoWrapperActive');
  $iframe.attr('src','');
  
}


$(".close").click(function(){
  $(".youtube-popup .videoIframe").attr('src','');
  $(".youtube-popup").fadeOut(1000);
  $(".overlay").fadeOut(500);
});

  /*--------------------- // Video section -----------------------*/
  
  
  

  $('body').on('click', '.shopify_explorer_faq__question', function() {
    $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });
  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
  });
  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
  });
  
  
  
  
  
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  
 function isElementVisible($elementToBeChecked)
{
    var TopView = $(window).scrollTop();
    var BotView = TopView + $(window).height();
    var TopElement = $elementToBeChecked.offset().top;
    var BotElement = TopElement + $elementToBeChecked.height();
    return ((BotElement <= BotView) && (TopElement >= TopView));
}   

$(window).scroll(function () {
    $( ".number-count" ).each(function() {
    isOnView = isElementVisible($(this));
        if(isOnView && !$(this).hasClass('starting')){
           $(this).addClass('starting');
           startTimerCounter($(this));
        }
    });
});
  
$(window).scroll(function () {
    $( ".progressbar-line" ).each(function() {
    isOnView = isElementVisible($(this));
        if(isOnView && !$(this).hasClass('starting')){
           $(this).addClass('starting');
           startTimerProgressBar($(this));
        }
    });
});  
  

  
  
function startTimerCounter($this) {
  
     $this.prop('Counter',0).animate({
        Counter: $this.text().replaceAll('.','')
    }, {
        duration: 2000,
        easing: 'swing',
        step: function (now) {
        $this.text(Math.ceil(now));

          var str = $this.html() + ''; 
          x = str.split('.'); 
          x1 = x[0]; x2 = x.length > 1 ? '.' + x[1] : ''; 
          var rgx = /(\d+)(\d{3})/; 
          while (rgx.test(x1)) { 
              x1 = x1.replace(rgx, '$1' + '.' + '$2'); 
          } 
          $this.html(x1 + x2); 

        }
    });
  
}  
  
  
  function startTimerProgressBar($this){
      $this.prop('Counter',0).animate({
        Counter: $this.data('position')
    }, {
        duration: 2000,
        easing: 'swing',
        step: function (now) {
          var cp = Math.ceil(now);
           $this.attr("style","width: "+cp+"%;");
           $this.parent().find(".flag[data-position="+cp+"]").removeClass('inactive').addClass('active');
        }
    }); 
    
  }  
  
  
  function percentage(current,total){
    var perct  = Math.round((parseInt(current)/parseInt(total))*100);
    if(perct >=1){
      return perct;
    }else{
     return 0;
    }
  }
  
  
  /*  --------------  Product ------------------------*/
  
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.slider-for',
    arrows: true,
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});
  
  
  /*------------------// Product ----------------------*/
  
  
  
  
  
  

$('.swatch :radio').change(function() {
var optionIndex = $(this).closest('.swatch').attr('data-option-index');
var optionValue = $(this).val();
$(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
  
  
  $("#ProductSelect-product-template").find('option:selected').removeAttr('selected');
  
  $(".swatch[data-option-index="+optionIndex+"] .swatch-element").removeClass('selected');
  
  
  
  $('#ProductSelect-product-template option').each(function(i, e) {
    if($.trim($(e).text())== $.trim(optionValue)){
       $(e).attr("selected","selected");
      	
        $(".swatch[data-option-index="+optionIndex+"] .swatch-element[data-value='"+$.trim(optionValue)+"']").addClass('selected');
      	
      
     }
  
});
  
  
});
  
  
  
$('.swatch[data-option-index="0"] :radio').change(function() {
  $('.swatch[data-option-index="0"] .swatch-element').removeClass('active');
  $(this).parent().addClass('active');
});
  $('.swatch[data-option-index="1"] :radio').change(function() {
  $('.swatch[data-option-index="1"] .swatch-element').removeClass('active');
  $(this).parent().addClass('active');
});



 
  
});

function setCookie(cname, cvalue, exdays="1") {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
   var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
